import { RouteObject } from 'react-router'
import { RegisterPage } from '../pages/register'
import { OnboardingProvider } from '../components/onboarding-provider'
import { TenantOnboardingStage } from '$api-client/types.gen'
import { RoutePath } from 'src/enums/routing'
import { UnprotectedOnly } from '$features/auth/components/guards/unprotected-only'

export enum OnboardingRoutePath {
  Register = '/register',
  BusinessDetails = '/business-details',
}

export const publicOnboardingRoutes: RouteObject[] = [
  {
    path: OnboardingRoutePath.Register,
    element: (
      <OnboardingProvider>
        <UnprotectedOnly>
          <RegisterPage />
        </UnprotectedOnly>
      </OnboardingProvider>
    ),
  },
]

export const ONBOARDING_SEQUENCE = [
  TenantOnboardingStage.REGISTER,
  TenantOnboardingStage.BUSINESS_DETAILS,
  TenantOnboardingStage.FINISHED,
] as const

export const ONBOARDING_SEQUENCE_ROUTES = {
  [TenantOnboardingStage.REGISTER]: OnboardingRoutePath.Register,
  [TenantOnboardingStage.BUSINESS_DETAILS]: OnboardingRoutePath.BusinessDetails,
  [TenantOnboardingStage.FINISHED]: RoutePath.Root,
} as const
